import EDPRsvpModule from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPRsvpModule/EDPRsvpModule';
import { withEDPRsvpModuleProps } from 'viewModel/happening/withEDPRsvpModuleProps';

export default withEDPRsvpModuleProps(EDPRsvpModule);
